import React from 'react';

import i18n from '@client/utils/i18n';
import { SpectralRanges } from '@ledium/types';
import { Slider, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

interface SliderChannelRanges {
    pfd: SpectralRanges;
    irradiance: SpectralRanges;
}

interface SliderChannel {
    id: string;
    resolution: number;
    intensity: number;
    spectrogramRanges: SliderChannelRanges;
}

interface LightChannelIntensitySliderProps {
    channel: SliderChannel;
    intensityUnit: 'pfd' | 'irradiance';
    readOnly?: boolean;
    onSliderChange: (id: string, value: number) => void;
}

const LightChannelIntensitySlider = ({ channel, intensityUnit, readOnly, onSliderChange }: LightChannelIntensitySliderProps) => {
    function getAriaValueText(value: number) {
        return `${value}`;
    }

    function onChange(_e: Event, value: number | number[]) {
        onSliderChange(channel.id, Array.isArray(value) ? value[0] : value);
    }

    const min = 0;
    const max = 2 ** channel.resolution - 1;
    const maxValue = Math.round(channel.spectrogramRanges[intensityUnit].sum);
    const unit = i18n(intensityUnit + '_unit') as string;
    return (
        <>
            <Stack spacing={1} direction="row" sx={{ mb: 0, width: '100%' }} alignItems="center">
                <Typography variant="body2">{min}</Typography>
                <Slider
                    value={channel.intensity}
                    getAriaValueText={getAriaValueText}
                    step={1}
                    valueLabelDisplay="auto"
                    disabled={!!readOnly}
                    onChange={onChange}
                    size="small"
                    min={min}
                    max={max}
                />
                <Typography variant="body2">{maxValue}</Typography>
            </Stack>
            <Typography variant="body2" sx={{ width: '100%', textAlign: 'center', mb: 1, mt: '-10px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)' }}>
                {unit}
            </Typography>
        </>
    );
};

export default LightChannelIntensitySlider;
